import React, { createContext, useState, useContext, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [isRTL, setIsRTL] = useState(false);

  const toggleLanguage = () => {
    setIsRTL((prevIsRTL) => !prevIsRTL);
  };

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.body.dir = isRTL ? "rtl" : "ltr";

    // Trigger translation of all text in the project
    document.dispatchEvent(
      new CustomEvent("translateAll", {
        detail: { toLanguage: isRTL ? "ar" : "en" },
      })
    );
  }, [isRTL]);

  return (
    <LanguageContext.Provider value={{ isRTL, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
